<template>
  <BaseNode
    :node="node"
    :editor-errors="editorErrors"
    color="#666"
  >
    {{text}}
  </BaseNode>
</template>

<script>
import nodeMixin from './nodeMixin'

export default {
  mixins: [nodeMixin],
  computed: {
    text() {
      return this.$t(`trigger.type.${this.node.triggerType}.label`)
    }
  }
}
</script>
